import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AiOutlineTool } from 'react-icons/ai'
import logo from '../../assets/logo.png'

const MaintenanceOverlay = () => {
    const { isMaintenance, detectedAt } = useSelector(
        (state) => state.maintenance
    )
    const [now, setNow] = useState(() => Date.now())

    useEffect(() => {
        if (!isMaintenance) return undefined
        setNow(Date.now())
        const id = setInterval(() => setNow(Date.now()), 1000)
        return () => clearInterval(id)
    }, [isMaintenance])

    if (!isMaintenance) return null

    const elapsedSec = detectedAt
        ? Math.max(0, Math.floor((now - detectedAt) / 1000))
        : 0
    const mm = Math.floor(elapsedSec / 60).toString().padStart(2, '0')
    const ss = (elapsedSec % 60).toString().padStart(2, '0')

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: '#f4f5f7',
                zIndex: 1055,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '24px',
            }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="maintenance-overlay-title"
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                    padding: '48px 40px',
                    maxWidth: '460px',
                    width: '100%',
                    textAlign: 'center',
                }}
            >
                <img
                    src={logo}
                    alt="Logo"
                    style={{ height: '40px', marginBottom: '32px', objectFit: 'contain' }}
                />

                <div
                    style={{
                        width: '72px',
                        height: '72px',
                        borderRadius: '50%',
                        backgroundColor: '#e1edff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px',
                    }}
                >
                    <AiOutlineTool size={36} color="#0081f2" />
                </div>

                <h2
                    id="maintenance-overlay-title"
                    style={{
                        fontSize: '1.4rem',
                        fontWeight: 700,
                        color: '#172b4d',
                        marginBottom: '12px',
                    }}
                >
                    System Maintenance
                </h2>

                <p style={{ color: '#6b778c', fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '28px' }}>
                    The server is temporarily unavailable. We'll automatically
                    restore the page as soon as services are back online —{' '}
                    <strong>no refresh needed.</strong>
                </p>

                <div
                    style={{
                        backgroundColor: '#f4f5f7',
                        borderRadius: '8px',
                        padding: '14px 20px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontSize: '0.875rem',
                        color: '#6b778c',
                    }}
                >
                    <span
                        style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: '#0081f2',
                            display: 'inline-block',
                            animation: 'maintenance-pulse 1.4s ease-in-out infinite',
                        }}
                    />
                    Waiting since <strong style={{ color: '#172b4d', marginLeft: '4px' }}>{mm}:{ss}</strong>
                </div>
            </div>

            <style>{`
                @keyframes maintenance-pulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.4; transform: scale(0.85); }
                }
            `}</style>
        </div>
    )
}

export default MaintenanceOverlay
